import { useEffect, useState } from "react"
import { CashFlowClassification, } from "../../../helpers/interfaces"
import { FormEditMode } from "../../../helpers/constants"
import { createGTBClassification as createCashFlowClassification, updateGTBClassification as updateCashFlowClassification } from "../../../apiServices/GTBMappingKeysApi"
import CustomDialog from "../../CustomDialog"
import { CustomTextField } from "../../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"


interface Props {
    setCashFlowClassification:React.Dispatch<React.SetStateAction<CashFlowClassification[]>>
    cashFlowClassification: CashFlowClassification[]
    openCashFlowClassificationForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenCashFlowClassificationForm:React.Dispatch<React.SetStateAction<boolean>>
    cashFlowClassificationToEdit:string
    cashFlowClassificationEditMode:number
}
function CreateEditCashFlow(props: Props) {
    const [ cashFlowClassificationName, setCashFlowClassificationName] = useState<string>("");
    
    useEffect(() => {
        if (props.cashFlowClassificationEditMode === FormEditMode.EDIT) {
            var _cashFlowClassificationName = props.cashFlowClassification.find(e => e.id === props.cashFlowClassificationToEdit)
            if (!_cashFlowClassificationName) return
            setCashFlowClassificationName(_cashFlowClassificationName.name)
           
        }
    }, [props.cashFlowClassification, props.cashFlowClassificationEditMode, props.cashFlowClassificationToEdit])

    function createNewCashFlowClassification() {
        createCashFlowClassification( cashFlowClassificationName).then(_cfc=> {
            props.setOpenCashFlowClassificationForm(false);
            props.setCashFlowClassification(cfc => [...cfc, _cfc])
            
        })
    }
    function updateNewCashFlowClassification() {
        updateCashFlowClassification(props.cashFlowClassificationToEdit,  cashFlowClassificationName).then(result => {
            props.setOpenCashFlowClassificationForm(false);
            props.setCashFlowClassification(cfc => cfc.map(a=> a.id === props.cashFlowClassificationToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.cashFlowClassificationEditMode === FormEditMode.CREATE ? 'Add Cash Flow Classification ' : 'Update Cash Flow Classification '} setOpenDialog={props.setOpenCashFlowClassificationForm} openDialog={props.openCashFlowClassificationForm}>
            <form>
                <div >
                    <label className='title-label'>Cash Flow Classification Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="Cash Flow Classification Name" value={ cashFlowClassificationName} onChange={(e) => setCashFlowClassificationName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={! cashFlowClassificationName} variant="contained" color='secondary' onClick={props.cashFlowClassificationEditMode === FormEditMode.CREATE ? createNewCashFlowClassification : updateNewCashFlowClassification} >
                        <Add />&nbsp; {props.cashFlowClassificationEditMode === FormEditMode.CREATE ? 'Add New Cash Flow Classification' : 'Update Cash Flow Classification'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditCashFlow